import React, { useEffect } from 'react';
import org from 'static/images/org.png';
import doctor from 'static/images/doctor.png';
import exchange from 'static/images/exchange.png';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import { getCognitoUserInfo, getAuthHeader, request } from 'components/auth'
import { Link } from 'react-router-dom';
import axios from 'axios'

//const { apiEndpoint, apiKey } = require('config')  //changed the config file
const { api, apiKey, authEndpoint, apiEndpoint } = require('../../config')

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainHeader: {
      margin: '.75em 0'
    },
    largeSpacer:{
      marginTop: '7.5%'
    },
    root: {
      flexGrow: 1,
    },
    column: {
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    clickableIcon: {
      textAlign: 'center',
      '& p': {
        textAlign: 'center'
      },
      '&:hover': {
        background: '#ccc',
        boxShadow: '5px 40px -10px rgba(0,0,0,0.57)',
        transition: 'all 0.4s ease 0s'
      }
    },
  }),
);

export default function HomePage(props: any) {
  const classes = useStyles();

  const getUser = async () => {
    let response = await axios({
      url: `${apiEndpoint}/user`,
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
        'Authorization': getAuthHeader()
      },
      responseType: "json"
    });
    return response.data
  }

  useEffect(() => {
    const cognitoUser = getCognitoUserInfo()
    if(cognitoUser) {
      getUser()
      .then(user => {
        if(user === null || (user || {}).id === undefined) {
          props.history.push('/profile')
        }
      })
      .catch(console.log)
    }
  }, []);
  
  return (
    <main>
      <div className={classes.largeSpacer}></div>
      <Typography variant="h1" align="center" className={classes.mainHeader}>USCC ServicePlace</Typography>
      <Typography variant="h2" align="center">Serving communities by matching needs to those who can help</Typography>
      <div className="Touts">
        <Grid direction="column" container alignItems="center" >
          <Grid item lg={4} sm={12} className={classes.clickableIcon}>
            <Link to="#" target="_self" onClick={_ => { window.location.href=`${authEndpoint}/login` }}>
              <img src={doctor} alt="Individual" /> <br/>
              <Typography className={classes.column}>Register as an individual provider</Typography>
            </Link>
          </Grid>
          <Grid item lg={4} sm={12} className={classes.clickableIcon}>
            <Link to='#' target='_self' onClick={_ => {
                window.location.href="mailto:Contact@usciviliancorps.org";
                return false;
              }}>
              <img src={org} alt="Org" /> <br/>
              <Typography className={classes.column}>Register as an organization to search for volunteers and manage engagements</Typography>
            </Link>
          </Grid>
          <Grid item lg={4} sm={12} className={classes.clickableIcon}>
            <Link to='/about'>
              <img src={exchange} alt="Exchange" /> <br/>
              <Typography className={classes.column}>Learn more about the USCC and the ServicePlace platform</Typography>
            </Link>
          </Grid>
        </Grid>
      </div>
    </main>
  );
}